export default "__VITE_ASSET__BxmTF52V__"